<script setup lang="ts">
const props = defineProps<{
  stepNumber: number | string;
  label: string;
  showCheckmark?: boolean;
}>();
</script>

<template>
  <div class="mbw-step" v-bind="$attrs">
    <div class="mbw-step-badge">
      {{ props.stepNumber }}
    </div>
    <div class="mbw-step-label">
      {{ props.label }}
    </div>
    <div v-if="props.showCheckmark" class="mbw-step-check">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="10" fill="#7CAB76"/>
        <path d="M5 10.0001L8.33333 13.3334L15 6.66675" stroke="white" stroke-width="1.66667"/>
      </svg>
    </div>
  </div>
</template>

